<template>
  <div class="act_layout">
    <div class="lv_flexalign_center">
      <van-slider
        v-model="size"
        @input="handleInput"
        :min="0.5"
        :max="2"
        :step="0.1"
        bar-height="4px"
        inactive-color="#999"
        active-color="#6e9f21"
      />
      <div class="slider_text">
        {{ size }}
      </div>
    </div>
    <div class="light_row lv_flexalign_center">
      <span>器皿光感</span>
      <van-switch
        v-model="lightEnabled"
        size="22px"
        active-color="#6e9f21"
        inactive-color="#dcdcdc"
        @change="handleLightChange"
      />
    </div>
    <div class="act_button" @click="remove">删除</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      size: 1,
      id: "",
      lightEnabled: false,
    };
  },
  methods: {
    handleInput() {
      this.$bus.$emit("setSize", {
        id: this.id,
        value: this.size,
      });
    },
    remove() {
      this.$bus.$emit("remove", this.id);
    },
    handleLightChange() {
      this.$bus.$emit("setContainerLight", this.lightEnabled);
    },
  },
  mounted() {
    this.$bus.$on("container-add", (val) => {
      this.id = val.id;
      this.size = val.params.size;
      this.lightEnabled = !!val.containerLight;
    });
  },
};
</script>
<style lang="scss" scoped>
.light_row {
  justify-content: space-between;
  margin-top: rem(28);
  font-size: rem(24);
  color: #333;
}

.act_button {
  margin-top: rem(35);
}
</style>
